export default __webpack_public_path__ + "static/media/he_notification.312211e8.mp3";